import React from 'react'
import { Dropdown } from 'antd'
import chatIcon from "../../../../assets/cometchat/images/resources-chat.svg";
import developerDocsIcon from "../../../../assets/cometchat/images/resources-developer-docs.svg"
import apiDocsIcon from "../../../../assets/cometchat/images/resources-api-docs.svg"
import sampleAppsIcon from "../../../../assets/cometchat/images/resources-sample-apps.svg"
import helpCenterIcon from "../../../../assets/cometchat/images/resources-help-center.svg"
import communityIcon from "../../../../assets/cometchat/images/resources-community.svg"
import productUpdatedIcon from "../../../../assets/cometchat/images/resources-product-updates.svg"
import productFeedbackIcon from "../../../../assets/cometchat/images/resources-product-feedback.svg"
import officeHoursIcon from "../../../../assets/cometchat/images/resources-office-hours.svg"
import statusPageIcon from "../../../../assets/cometchat/images/resources-status-page.svg"
import style from './style.module.scss'

const HelpMenu = () => {
  const resourcesMenu = [{
    title: "Create support ticket",
    link: "https://help.cometchat.com/hc/en-us/requests/new",
    icon: chatIcon
  }, {
    title: "Developer docs",
    link: "https://www.cometchat.com/docs/",
    icon: developerDocsIcon
  }, {
    title: "API docs",
    link: "https://api-explorer.cometchat.com/reference/chat-apis",
    icon: apiDocsIcon
  }, {
    title: "Sample apps",
    link: "https://github.com/cometchat",
    icon: sampleAppsIcon
  }, {
    title: "Help center",
    link: "https://help.cometchat.com/hc/en-us",
    icon: helpCenterIcon
  }, {
    title: "Community",
    link: "https://community.cometchat.com/",
    icon: communityIcon
  }, {
    title: "Product updates",
    link: "https://www.cometchat.com/blog?category=Product%20Updates",
    icon: productUpdatedIcon
  }, {
    title: "Product feedback",
    link: "https://feedback.cometchat.com/",
    icon: productFeedbackIcon
  }, {
    title: "Office hours",
    link: "https://cometchat.com/office-hours",
    icon: officeHoursIcon
  }, {
    title: "Status page",
    link: "https://status.cometchat.com/",
    icon: statusPageIcon
  }];

  const menu = (
    <div className={style.appNavMenuCustomSubMenu}>
      {resourcesMenu.map((resource) => (
        <div className={style.appNavMenuCustomItem}>
          <a
            href={resource.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className={style.appNavMenuResourcesWrapper}>
              <img src={resource.icon} alt={resource.title} width={20} height={20} />
              <div>{resource.title}</div>
            </div>
          </a>
        </div>
      ))}
    </div>
  )
  return (
    <Dropdown overlay={menu} trigger={['click']}>
      <img
        style={{ marginRight: '24px' }}
        src="/resources/images/v2-dashboard/topNav-intercom-icon.png"
        alt="intercom"
        id="contactus"
      />
    </Dropdown>
  )
}

export default HelpMenu
